import React, { useState } from "react";
import "../common/styles/sidebar.css";
import logoimage from "../assets/image/ListIt.png";
import { connect } from "react-redux";


import back_btn from "../assets/image/sidebarIcons/back_btn.svg";
import toggle_btn_icon from "../assets/image/sidebarIcons/toggle_btn_sidebar.png";
import { hideSideBar,showSideBar } from "../../redux/actionDispatcher/admin/showSideBarDispather";


const Sidebar = ({ hideSideBar, showSideBar, isPlaying, play, Options }) => {
  const [toggle, setToggle] = useState(false);

  const handleClick = () => {
    play(!isPlaying);
    if (toggle) {
      setToggle(false);
      hideSideBar();
    } else {
      setToggle(true);
      showSideBar();
    }
  };



  // getSelectValue();
  return (
    <>
      <div id="sidebar" >
        <input type="checkbox" id="check" />
        <div className="sidebar toggle_animation">
          <center className="images_sidebar toggle_animation">
            <label htmlFor="check">
              <img
                className="fas fa-chevron-left"
                id="sidebar_btn"
                onClick={handleClick}
                src={!toggle ? back_btn : toggle_btn_icon}
                style={{ marginBlockEnd: "-161vh" }}
                alt="back"
              />
            </label>

            {!toggle ? (
              <>
                <img src={logoimage} className="profile_image1" alt="" />
              </>
            ) : (
              <>
                {/* <img src={david} className="small_logo_avtar" alt="" /> */}
                <img src=""  className="profile_image2" alt="" />
                {/* <img src={logo} className="small_logo" alt="" /> */}
              </>
            )}
            
          </center>
          <main>

            <Options Toggle={toggle} />

          </main>
        </div>
        <div />
      </div>
    </>
  );
};

//Getting the state from the store

//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    showSideBar: () => dispatch(showSideBar()),
    hideSideBar: () => dispatch(hideSideBar()),
  };
};

//Connecting the component to our store
export default connect(null, mapDispatchToProps)(Sidebar);
